import {BaseTerms} from "../../infrastructure/models/base-terms";

export class H2hWidgetTerms extends BaseTerms {
  WEB_GC_HOME = "Home";
  WEB_GC_AWAY = "Away";
}
